import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-navy" data-id="element-88" data-mp="9lbfcytwl7cj">
      <div className="mx-auto max-w-2xl px-4 pb-6 pt-5 text-center sm:px-6 sm:pt-7" data-id="element-89" data-mp="4lqiqv27hb2z">
        <p className="inline-flex items-center gap-1.5 rounded-full border border-electric/50 bg-electric/10 px-3 py-1 font-display text-[0.7rem] font-bold uppercase tracking-wide text-electric" data-id="element-90" data-mp="4jm7fs1z99so">
          🛡️ Método de aprendizaje paso a paso
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="mt-2.5 font-display text-[1.6rem] font-black leading-[1.12] text-white sm:text-[2.4rem]" data-id="element-91" data-mp="sa9szg4tfxxp">
          El sistema completo para{' '}
          <span className="text-electric" data-id="element-92" data-mp="380vyvxmf4td5">aprender seguridad electrónica</span>{' '}
          desde cero
        </motion.h1>

        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/80 sm:text-base" data-id="element-93" data-mp="3j6g1pzwctvil">
          Aprende una habilidad técnica, comprende cómo funcionan los sistemas de
          seguridad electrónica más utilizados y abre nuevas posibilidades —{' '}
          <strong className="font-semibold text-white" data-id="element-94" data-mp="3e8ecex8c4zyo">
            sin perderte entre cientos de videos, manuales y tutoriales.
          </strong>
        </p>

        <p className="mt-3 rounded-lg bg-gold px-3 py-1.5 font-display text-[0.72rem] font-extrabold uppercase leading-tight text-navy sm:text-sm" data-id="element-95" data-mp="358hleoyh3p0g">
          🛡️ MEGA PACK TÉCNICO EN SEGURIDAD ELECTRÓNICA · 6 Tomos + 5 Bonos
        </p>

        <motion.a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-2 block max-w-md" data-id="element-96" data-mp="2vjzmkd9r7rzg">
          <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="w-full" data-id="element-97" data-mp="s3mb9x0ezovq" />
        </motion.a>

        <p className="mt-1 font-display text-[0.7rem] font-semibold text-white/70 sm:text-xs" data-id="element-98" data-mp="n9qid8z0cs7f">
          MEGA PACK TÉCNICO EN SEGURIDAD ELECTRÓNICA: 6 tomos digitales y 5 bonos
          incluidos
        </p>

        <CtaButton className="mt-3" tone="dark" note="Acceso Digital Inmediato • Garantía de 7 Días" data-id="element-99" data-mp="deylk7d929dp">
          🚀 SÍ, QUIERO COMENZAR AHORA
        </CtaButton>
      </div>
    </header>;
}